import { __assign, __extends } from "tslib";
import * as _ from '@antv/util';
import Adjust from './adjust';
var Symmetric = /** @class */ (function (_super) {
    __extends(Symmetric, _super);
    function Symmetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Symmetric.prototype.process = function (groupDataArray) {
        var mergeData = _.flatten(groupDataArray);
        var _a = this, xField = _a.xField, yField = _a.yField;
        // æ¯ä¸ª x å¼å¯¹åºç æå¤§å¼
        var cache = this.getXValuesMaxMap(mergeData);
        // æææ°æ®çæå¤§çå¼
        var max = Math.max.apply(Math, Object.keys(cache).map(function (key) { return cache[key]; }));
        return _.map(groupDataArray, function (dataArray) {
            return _.map(dataArray, function (data) {
                var _a, _b;
                var yValue = data[yField];
                var xValue = data[xField];
                // æ°ç»å¤çé»è¾
                if (_.isArray(yValue)) {
                    var off_1 = (max - cache[xValue]) / 2;
                    return __assign(__assign({}, data), (_a = {}, _a[yField] = _.map(yValue, function (y) { return off_1 + y; }), _a));
                }
                // éæ°ç»å¤çé»è¾
                var offset = (max - yValue) / 2;
                return __assign(__assign({}, data), (_b = {}, _b[yField] = [offset, yValue + offset], _b));
            });
        });
    };
    // è·åæ¯ä¸ª x å¯¹åºçæå¤§çå¼
    Symmetric.prototype.getXValuesMaxMap = function (mergeData) {
        var _this = this;
        var _a = this, xField = _a.xField, yField = _a.yField;
        // æ ¹æ® xField çå¼è¿è¡åç»
        var groupDataArray = _.groupBy(mergeData, function (data) { return data[xField]; });
        // è·åæ¯ä¸ª xField å¼ä¸­çæå¤§å¼
        return _.mapValues(groupDataArray, function (dataArray) { return _this.getDimMaxValue(dataArray, yField); });
    };
    Symmetric.prototype.getDimMaxValue = function (mergeData, dim) {
        // ææç value å¼
        var dimValues = _.map(mergeData, function (data) { return _.get(data, dim, []); });
        // å°æ°ç»æå¹³ï¼dim value æå¯è½æ¯æ°ç»ï¼æ¯å¦ stack ä¹åçï¼
        var flattenValues = _.flatten(dimValues);
        // æ±åºæ°ç»çæå¤§å¼
        return Math.max.apply(Math, flattenValues);
    };
    return Symmetric;
}(Adjust));
export default Symmetric;
//# sourceMappingURL=symmetric.js.map